import React from "react";
//import { Redirect } from "react-router-dom";
import Logo from "../assets/img/png/logo-white.png";
import LogoUE from "../assets/img/jpg/logo_FondoEuropeo.jpg";
import logoGobAragon from "../assets/img/jpg/logo_GobiernoAragon.jpg";

import "./Contact.scss";

export default function Contact() {
  return (
    <div className="contact">
      <div className="contactback">
          <a href="/" className="contactback-pictureAndLogo-logo">
            <img src={Logo} alt="logo" />
          </a>
          <a href="/admin/login" className="button" >
              Iniciar sesión
          </a>
      </div>
      <div className="descriptionct">
        <h1 className="descriptionct-title">
            DIGITALIZACIÓN Y LOGÍSTICA SOSTENIBLES
            
        </h1>
        <h1 className="descriptionct-subtitle">
            PARA EQUILIBRAR LA ECONOMÍA, LAS CIUDADES Y EL TERRITORIO
        </h1>
        <div className='contacto'>
          <h1 className="contacto-knowMore">
            Escríbenos {'>'} {'>'}
          </h1>
          <div  className="contacto-button" >
            project@capillar.it
          </div>
        </div>
      </div>
      <div className="brownct">
          <h1 className="brownct-logoGobAragon">
            <img src={logoGobAragon} alt="logoGobAragon" />
          </h1>
          <h1 className="brownct-logoUE">
            <img src={LogoUE} alt="logoUE" />
          </h1>
      </div>
      <div className="blackct">
          <h1 className="blackct-init">
           Web en construcción.
          </h1>
          <h1 className="blackct-end">
            2022
          </h1>
      </div>
    </div>
      
  );
}
